// Import package components
import { useContext } from "react";
import UIkit from "uikit";

// Import base components
import { AppContexts } from "../../../providers";

// Import common components
import Dialog from "../../common/Dialog";
import { removeGuideSection } from "./section_state";

const normalizeOrdering = (ordering = []) => {
  const seen = new Set();

  return (ordering || []).filter((value) => {
    const numericValue = Number(value);

    if (!Number.isFinite(numericValue) || numericValue <= 0) {
      return false;
    }

    const key = String(numericValue);
    if (seen.has(key)) {
      return false;
    }

    seen.add(key);
    return true;
  });
};

const MasterDelete = () => {
  const { updateSection, selectedSection, selectedTab, setSelectedSection } =
    useContext(AppContexts.RentalsContext);
  const { get, set, settings } = useContext(AppContexts.SettingsContext);
  const { refresh, setUser } = useContext(AppContexts.AuthContext);

  const handleDelete = async () => {
    let [success, error] = await updateSection({ ...selectedSection, suspended: true });
    if (success) {

      let orders = settings?.welcome_order;
      if (!orders) {
        const loadedSettings = await get(["welcome_order"]);
        orders = loadedSettings?.welcome_order;
      }

      console.log("Selected Section:", selectedTab);
      if (!selectedTab) {
        return UIkit.notification("Failed", "error");
      }

      let selectedOrder = orders.find((o) => o.type === selectedTab.type);
      console.log("Selected Order", selectedOrder);
      if (!selectedOrder) {
        return UIkit.notification("Failed", "error");
      }

      const nextOrders = orders.map((order) =>
        order.type === selectedTab.type
          ? {
              ...order,
              ordering: normalizeOrdering(
                (order.ordering || []).filter(
                  (item) =>
                    item?.toString() !==
                    selectedSection.welcome_guide_question_id?.toString(),
                ),
              ),
            }
          : order,
      );
      await set("welcome_order", nextOrders);
      setSelectedSection(null);

      await refresh();
      setUser((current) => current ? {
        ...current,
        welcome_guide: removeGuideSection(
          current.welcome_guide,
          selectedSection.welcome_guide_question_id,
        ),
      } : current);

    } else {
      UIkit.notification("Failed", "error");
    }

    UIkit.notification("Removed Successfully", "success");

    UIkit.modal("#master-property-delete").hide();
  };

  return (
    <>
      <Dialog id="master-property-delete">
        <div className="uk-modal-dialog uk-modal-body">
          <button
            className="uk-modal-close-default"
            type="button"
            uk-close="true"
          ></button>
          <h2 className="uk-modal-title">Delete Block</h2>
          <p>
            Are you sure you want to delete?{" "}
            <b>Warning: This step cannot be reversed.</b>
          </p>
          <p className="uk-text-right">
            <button
              className="uk-button hms-btn uk-modal-close uk-modal-delete-cancel"
              type="button"
            >
              Cancel
            </button>
            <button
              className="uk-button hms-btn hms-gray-btn"
              type="button"
              onClick={handleDelete}
            >
              Delete
            </button>
          </p>
        </div>
      </Dialog>
    </>
  );
};

export default MasterDelete;
